import { getLatestPaymentForOthers, getOthersBills } from '../../api/services'
import IMAGES from '../../assets/images'
import {
  downloadPicFromAPI,
  getAvailableProgramsAPi,
  getBillsInfoAPi,
  getCustomerInfoApi,
  // eslint-disable-next-line prettier/prettier
  getCustomerPackageInfoApi,
  getInstallmentsAPI,
  getNotificationFromAPI,
  getPackageDetailsAPi,
  getServiceInfoFromAPI,
  getQuickAccessPagesListApi,
  getProfileDataFromApi,
} from './../../api/customerInfo/index'
import {
  FAILED_SET_CUSTOMER_INFO,
  FAILED_SET_CUSTOMER_PACKAGE_INFO,
  GET_NOTIFICATIONS_LIST,
  SET_ACTIVE_SERVICES,
  SET_AVAILABLE_PROGRAMS,
  SET_BILLS_DATA,
  SET_CUSTOMER_INFO,
  // eslint-disable-next-line prettier/prettier
  SET_CUSTOMER_PACKAGE_INFO,
  SET_INSTALLMENTS,
  SET_PACKAGE_DETAILS,
  SET_PROFILE_PICTURE,
  SET_ACCESS_PAGE_LIST,
  SET_PROFILE_DATA,
  SET_LATEST_PAYMENT_FOR_OTHERS,
  SET_REFLECT_INFO,
} from './actionsTypes'

export const getCustomerInfo = async (dispatch) => {
  getNotificationsList(dispatch)
  dispatch(setCustomerInfo({ isLoading: true }))
  const res = await getCustomerInfoApi()
  dispatch(setCustomerInfo({ ...res.data, loaded: true }))
  if (res.error) {
    dispatch(customerInfoFailed(res.error))
  }
}
export const getAvailablePrograms = async (dispatch) => {
  dispatch(setAvailablePrograms([]))
  const res = await getAvailableProgramsAPi()
  dispatch(setAvailablePrograms(res))
}

export const getPackageDetails = async (packageCode, dispatch) => {
  const res = await getPackageDetailsAPi(packageCode)
  dispatch(setPackageDetails(res.data))
}

export const getCustomerPackageInfo = async (dispatch) => {
  dispatch(setCustomerPackageInfo({}))
  const res = await getCustomerPackageInfoApi()
  dispatch(setCustomerPackageInfo(res.data))
  if (res.error) {
    dispatch(customerInfoFailed(res.error))
  }
}
export const getBillsInfo = async (dispatch) => {
  const res = await getBillsInfoAPi()
  dispatch(setBillsInfo(res))
}
export const getInstallmentInfo = async (dispatch) => {
  const res = await getInstallmentsAPI()
  dispatch(setInstallmentInfo(res))
}
export const getServiceInfo = async (dispatch) => {
  dispatch(setActiveServiceInfo({ isLoading: true }))
  const res = await getServiceInfoFromAPI()
  dispatch(setActiveServiceInfo(res))
}
export const getNotificationsList = async (dispatch) => {
  const res = await getNotificationFromAPI()
  dispatch(setNotificationsList(res))
}

export const getProfilePicture = async (dispatch) => {
  dispatch(setProfilePicture({ isLoading: true }))
  const res = await downloadPicFromAPI()
  if (res.hasImage) {
    dispatch(setProfilePicture({ src: `data:image/*;base64,${res.imgURL}` }))
  } else {
    dispatch(setProfilePicture({ src: IMAGES.defaultImageProfile }))
  }
}
export const getQuickAccessPagesList = async (dispatch) => {
  dispatch(setAccessPageList({ isLoading: true }))
  const res = await getQuickAccessPagesListApi()
  dispatch(setAccessPageList(res))
}

const REFLECT_INFO_STORAGE_KEY = 'hesabi_reflect_info'

const buildReflectInfoFromApi = (reflectInfo) => {
  if (!reflectInfo || typeof reflectInfo !== 'object') return null
  const displayedIban = reflectInfo.displayedIban ?? reflectInfo[' displayedIban'] ?? ''
  const rawIban =
    displayedIban ||
    reflectInfo.reflectIbanNis ||
    reflectInfo.reflectIbanJod ||
    reflectInfo.reflectIbanUsd ||
    null
  if (!rawIban) return null
  let currencyLabel = ''
  if (reflectInfo.reflectIbanNis && (displayedIban === reflectInfo.reflectIbanNis || (!displayedIban && reflectInfo.reflectIbanNis))) {
    currencyLabel = 'ILS'
  } else if (reflectInfo.reflectIbanJod && (displayedIban === reflectInfo.reflectIbanJod || (!displayedIban && reflectInfo.reflectIbanJod))) {
    currencyLabel = 'JOD'
  } else if (reflectInfo.reflectIbanUsd && (displayedIban === reflectInfo.reflectIbanUsd || (!displayedIban && reflectInfo.reflectIbanUsd))) {
    currencyLabel = 'USD'
  } else if (reflectInfo.reflectIbanNis) {
    currencyLabel = 'ILS'
  } else if (reflectInfo.reflectIbanJod) {
    currencyLabel = 'JOD'
  } else if (reflectInfo.reflectIbanUsd) {
    currencyLabel = 'USD'
  }
  const firstIbanDisplay = rawIban
  const ibanCurrency = currencyLabel ? { value: currencyLabel, label: currencyLabel } : null
  const formData = {
    reflectMobileNumber: reflectInfo.reflectMobileNumber || '',
    firstName: reflectInfo.firstNameEnglish || '',
    lastName: reflectInfo.secondNameEnglish || '',
    ibanNumber: rawIban,
    ibanCurrency,
    additionalIbans: [],
    additionalIbansCurrencies: {},
    additionalIbanValues: [],
  }
  return { firstIbanDisplay, formData }
}

export const getProfileData = async (dispatch) => {
  dispatch(setProfileData({ isLoading: true }))
  const res = await getProfileDataFromApi()
  dispatch(setProfileData(res))
  // Sync reflectInfo with ProfileData API: null → show empty state, has data → show IBAN (only when we have a response)
  if (res.data == null) return
  const apiReflectInfo = res.data.reflectInfo
  if (apiReflectInfo == null || typeof apiReflectInfo !== 'object') {
    dispatch(setReflectInfo(null))
    try {
      localStorage.removeItem(REFLECT_INFO_STORAGE_KEY)
    } catch (e) {
      // ignore
    }
    return
  }
  const apiDisplayedIban = res.data.displayedIban ?? apiReflectInfo.displayedIban ?? apiReflectInfo[' displayedIban']
  const reflectSource = { ...apiReflectInfo, displayedIban: apiDisplayedIban || (apiReflectInfo.displayedIban ?? apiReflectInfo[' displayedIban']) }
  if (res.data.eligibleForReflectData && reflectSource) {
    const payload = buildReflectInfoFromApi(reflectSource)
    if (payload) {
      dispatch(setReflectInfo(payload))
      try {
        localStorage.setItem(REFLECT_INFO_STORAGE_KEY, JSON.stringify(payload))
      } catch (e) {
        // ignore
      }
    } else {
      dispatch(setReflectInfo(null))
      try {
        localStorage.removeItem(REFLECT_INFO_STORAGE_KEY)
      } catch (e) {
        // ignore
      }
    }
  } else {
    dispatch(setReflectInfo(null))
    try {
      localStorage.removeItem(REFLECT_INFO_STORAGE_KEY)
    } catch (e) {
      // ignore
    }
  }
}

export const getLatestPaymentForOthersFromApi = async (dispatch) => {
  dispatch(setLatestPaymentForOthers({ isLoading: true }))
  const res = await getLatestPaymentForOthers()
  dispatch(setLatestPaymentForOthers(res))
}

export const setCustomerInfo = (CustomerInfo) => ({
  type: SET_CUSTOMER_INFO,
  payload: CustomerInfo,
})
export const setCustomerPackageInfo = (currentPackageInfo) => ({
  type: SET_CUSTOMER_PACKAGE_INFO,
  payload: currentPackageInfo,
})
export const setAvailablePrograms = (availablePackage) => ({
  type: SET_AVAILABLE_PROGRAMS,
  payload: availablePackage,
})
export const setPackageDetails = (packageDetails) => ({
  type: SET_PACKAGE_DETAILS,
  payload: packageDetails,
})

export const customerInfoFailed = (error) => ({
  type: FAILED_SET_CUSTOMER_INFO,
  payload: error,
})
export const setCustomerPackageInfoFailed = (error) => ({
  type: FAILED_SET_CUSTOMER_PACKAGE_INFO,
  payload: error,
})
export const setBillsInfo = (billsInfo) => ({
  type: SET_BILLS_DATA,
  payload: billsInfo,
})
export const setInstallmentInfo = (installmentInfo) => ({
  type: SET_INSTALLMENTS,
  payload: installmentInfo,
})
export const setActiveServiceInfo = (activeServiceInfo) => ({
  type: SET_ACTIVE_SERVICES,
  payload: activeServiceInfo,
})
export const setNotificationsList = (notificationsInfo) => ({
  type: GET_NOTIFICATIONS_LIST,
  payload: notificationsInfo,
})

export const setProfilePicture = (pictureSrc) => ({
  type: SET_PROFILE_PICTURE,
  payload: pictureSrc,
})
export const setAccessPageList = (accessPageList) => ({
  type: SET_ACCESS_PAGE_LIST,
  payload: accessPageList,
})

export const setProfileData = (data) => ({
  type: SET_PROFILE_DATA,
  payload: data,
})

export const setLatestPaymentForOthers = (data) => ({
  type: SET_LATEST_PAYMENT_FOR_OTHERS,
  payload: data,
})

export const setReflectInfo = (reflectInfo) => ({
  type: SET_REFLECT_INFO,
  payload: reflectInfo,
})
